import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";
import { ServiceFrequencyTypeDto, ServiceUnitTypeDto } from "../../interfaces/serviceDefinition/service-definition";
import { apiGet } from "../../utilities/api-client/apiRequest";




export async function GetAllServiceFrequencyTypesAsync(
    authToken: string,
): Promise<ApiResponse<ServiceFrequencyTypeDto[]>> {
    const apiUrl: string = `/ServiceFrequencyType/GetAllServiceFrequencyTypes`;

    var res = apiGet<ApiResponse<ServiceFrequencyTypeDto[]>>(
        apiUrl, authToken)

    return res;
}